import { ProductController, UserController } from "controllers";

const role = localStorage.getItem('role');

export const changeStatus = async (report, option) => {
  switch (option) {
    case 'washing':
    case 'fixed':
      await ProductController.updateReports(report, `declared_${option}`, role);
      break;
    case 'closet':
      await toCloset(report);
      ProductController.closeReports(report, `declared_${option}`, option, role);
      break;
    default:
      break;
  }
}

const toCloset = async (report) => {
  const { barcode } = report;
  const payload = { status: "available" };

  if (report.product) {
    const { currentUser, currentBox } = report.product;
    const item = await ProductController.getItemByBarcode(currentUser, currentBox, barcode);

    payload.currentUser = null;
    payload.currentBox = null;
    await ProductController.deleteProductLog(barcode, currentBox);

    await UserController.deleteUserBoxItems(currentUser, currentBox, item.id);
  }

  await ProductController.editProduct(barcode, payload);
}
